import { css } from '@emotion/css';
import {
  Dimensions2,
  Dimensions3,
  ColorsNeutral150,
  ColorsNeutral200,
  ColorsNeutral300,
  ColorsNeutral400,
} from '@efexteam/design-tokens';

const defaultContainer = css({
  width: '100%',
});

const headerOption = css({
  padding: `${Dimensions2} ${Dimensions3}`,
  borderBottom: `1px solid ${ColorsNeutral200}`,
  cursor: 'default',
});

const headerContent = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const headerLabel = css({
  fontWeight: 600,
  color: ColorsNeutral400,
});

const infoIcon = css({
  color: ColorsNeutral400,
  cursor: 'help',
});

const regularOption = css({
  padding: `${Dimensions2} ${Dimensions3}`,
  '&:hover': {
    backgroundColor: ColorsNeutral150,
  },
});

const optionContent = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const groupLabel = css({
  color: ColorsNeutral300,
  fontWeight: 500,
});

const listboxContainer = css({
  maxHeight: '384px',
  overflow: 'auto',
  padding: 0,
});

const countryAutocompleteStyles = {
  defaultContainer,
  headerOption,
  headerContent,
  headerLabel,
  infoIcon,
  regularOption,
  optionContent,
  groupLabel,
  listboxContainer,
};

export default countryAutocompleteStyles;
